module.exports = __webpack_public_path__ + "static/images/clipboard.f917ab9809b841989756d47920fd6b9c.svg";